<template>
    <div class="custom-work-executives-list">
        <CustomWorkExecutiveListItem
            v-for="(executive, i) in executives"
            :key="i"
            :editable="editable"
            :executive="executive"
            @remove="remove"
        />
    </div>
</template>
<script>
import CustomWorkExecutiveListItem from './CustomWorkExecutiveListItem.vue'

export default {
    components: {
        CustomWorkExecutiveListItem,
    },
    props: {
        editable: {
            type: Boolean,
            default: false,
        },
        executives: {
            type: Array,
            required: true,
        },
    },
    methods: {
        remove(executive) {
            this.$emit('remove', executive)
        },
    },
}
</script>
<style>
.custom-work-executives-list {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    height: 1%;
    overflow-y: auto;
    gap: 8px;
    padding: 8px 0;
}
</style>
